/* text-input.js — Theme-native text fields for engravings / personalization.
   Values stored as line-item properties (_prefix = hidden in cart, visible in order).
   Intercepts both form submit AND fetch/XHR to /cart/add for AJAX themes. */
(function () {
  'use strict';

  function getAllTextProps() {
    var props = {};
    document.querySelectorAll('.txtinp[data-prop-label]').forEach(function (el) {
      var input = el.querySelector('.txtinp__input');
      var prop  = el.getAttribute('data-prop-label');
      if (input && prop && input.value.trim()) {
        props['_' + prop] = input.value.trim();
      }
    });
    return props;
  }

  function injectProps(data, props) {
    if (data.items) {
      data.items.forEach(function (item) {
        item.properties = Object.assign({}, item.properties || {}, props);
      });
    } else if (data.id) {
      data.properties = Object.assign({}, data.properties || {}, props);
    }
  }

  var ajaxPatched = false;
  function patchAjax() {
    if (ajaxPatched) return;
    ajaxPatched = true;

    var origFetch = window.fetch;
    window.fetch = function (url, opts) {
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      if (urlStr.indexOf('/cart/add') !== -1 && opts && opts.body) {
        try {
          var props = getAllTextProps();
          if (Object.keys(props).length > 0) {
            if (typeof opts.body === 'string') {
              var data = JSON.parse(opts.body);
              injectProps(data, props);
              opts = Object.assign({}, opts, { body: JSON.stringify(data) });
            } else if (opts.body instanceof FormData) {
              Object.keys(props).forEach(function (k) {
                opts.body.set('properties[' + k + ']', props[k]);
              });
            }
          }
        } catch (e) { /* skip */ }
      }
      return origFetch.apply(this, arguments);
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._tiUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this._tiUrl && this._tiUrl.indexOf('/cart/add') !== -1 && typeof body === 'string') {
        try {
          var props = getAllTextProps();
          if (Object.keys(props).length > 0) {
            var data = JSON.parse(body);
            injectProps(data, props);
            body = JSON.stringify(data);
          }
        } catch (e) { /* skip */ }
      }
      return origSend.call(this, body);
    };
  }

  function boot() {
    document.querySelectorAll('.txtinp[data-prop-label]').forEach(function (el) {
      if (el._ti) return;
      el._ti = true;

      var input   = el.querySelector('.txtinp__input');
      var counter = el.querySelector('.txtinp__counter');
      var status  = el.querySelector('.txtinp__status');
      var maxLen  = parseInt(el.getAttribute('data-max-chars'), 10) || 0;
      var prop    = el.getAttribute('data-prop-label');
      var req     = el.getAttribute('data-required') === 'true';

      if (!input || !prop) return;

      if (counter && maxLen > 0) {
        input.addEventListener('input', function () {
          counter.textContent = input.value.length + '/' + maxLen;
          counter.classList.toggle('is-over', input.value.length > maxLen);
        });
      }

      input.addEventListener('input', function () {
        input.classList.remove('is-error');
        if (status) { status.textContent = ''; status.classList.remove('is-error'); }
      });

      var form = el.closest('form[action*="/cart/add"]')
              || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        var val = input.value.trim();

        var prev = form.querySelector('[data-ti-prop="' + prop + '"]');
        if (prev) prev.remove();

        if (req && !val) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.classList.add('is-error');
          input.focus();
          if (status) { status.textContent = 'שדה חובה'; status.classList.add('is-error'); }
          return;
        }
        if (maxLen > 0 && input.value.length > maxLen) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.classList.add('is-error');
          input.focus();
          return;
        }

        if (val) {
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'properties[_' + prop + ']';
          h.setAttribute('data-ti-prop', prop);
          h.value = val;
          form.appendChild(h);
        }
      });
    });

    patchAjax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
